<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M16 18C15.3267 19.7659 13.7891 21 12 21C10.2109 21 8.67327 19.7659 8 18M20 18L18.793 8.94737C18.339 5.54271 15.4348 3 12 3C8.56521 3 5.66097 5.5427 5.20702 8.94736L4 18H20Z"
    stroke="currentColor"
    stroke-width="2"
  />
</svg>
